export default __webpack_public_path__ + "static/media/p2.3d9bbefe.jpg";